export const ID = 'PROFILE';

export const SET_SHOW_TOOLTIPS = `${ID}/SET_SHOW_TOOLTIPS`;
